<template>
  <Popper
    class="infotooltip"
    :class="`infotooltip--${icon}`"
    arrow
    disable-click-away
    :offset-distance="'7'"
    :show="showPopper"
    v-bind="$attrs"
    @click.stop.prevent="() => {}"
  >
    <Icon :name="`${icon}-line`" class="trigger" @click="showPopper = !showPopper" />
    <template #content>
      <header v-if="heading" class="heading h6" v-html="heading"></header>
      <div class="content">
        <!-- @slot In dem Slot kann flexibel der Inhalt des Tooltips ausgestaltet werden (Text, HTML, Komponenten) -->
        <slot></slot>
      </div>
      <button class="close" title="Erklärungstext schließen" @click="showPopper = false">
        <Icon name="close-line" size="l" />
      </button>
    </template>
  </Popper>
</template>


<script lang="ts" setup>
import Popper from 'vue3-popper/dist/popper.esm'   //  https://valgeirb.github.io/vue3-popper/ (possible alternative: https://github.com/Akryum/floating-vue) + https://github.com/valgeirb/vue3-popper/issues/56 (using esm-version 2 prevent regeneratorRuntime-errors)
import Icon from '../Icon'
import { ref } from 'vue'

export interface InfoTooltipProps {
  heading?: string
  icon?: 'info' | 'help' | 'warning'
  show?: boolean
}

const {
  heading,
  icon = 'info',
  show = false,
} = defineProps<InfoTooltipProps>()

const showPopper = ref<boolean>(show || false)
</script>

<style lang="scss" scoped>
:deep(.trigger) {
  cursor: pointer;
  transform: translateY(.15rem);
}

:deep(.popper) {
  --popper-theme-background-color: var(--yellow);
  --popper-theme-background-color-hover: var(--yellow);
  --popper-theme-border-radius: .25rem;
  --popper-theme-padding: 1rem 2rem 1rem 1rem;
  --popper-theme-text-color: var(--neutral-80);
  --popper-theme-box-shadow: none;
  width: 30rem;
  max-width: 95vw;
}

:deep(.popper) > * {
  z-index: 1;
  position: relative;
}

:deep(.popper) header {
  padding-right: 2rem;
}

:deep(.popper) .content > *:last-child {
  margin-bottom: 0;
  padding-bottom: 0;
}

:deep(.popper) > #arrow {
  left: -.5rem!important;
  z-index: 0;
}

:deep(.popper[data-popper-placement^="bottom"]) > #arrow {
  top: -6px;
}

:deep(.popper[data-popper-placement^="top"]) > #arrow {
  bottom: 11px!important;
}

:deep(.popper) > #arrow::before {
  width: calc(1.5rem - var(--popper-theme-border-width, 0px));
  height: calc(1.5rem - var(--popper-theme-border-width, 0px));
}

:deep(.popper) .close {
  position: absolute;
  right: .25rem;
  top: .25rem;
  display: inline-flex;
  justify-content: center;
  align-items: center;
  box-sizing: border-box;
  padding: .25rem;
  border: 0;
  background-color: transparent;
  cursor: pointer;
}
</style>
